module.exports = __webpack_public_path__ + "Steven2.jpg?0e5253a8687b3dc3bf114ffc5cf9b8ca";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/customers/Steven2.jpg
// module id = 45
// module chunks = 0